// extracted by mini-css-extract-plugin
module.exports = {"Root":"AnchorLink_Root__gIFSV"};